import React, { useState } from 'react';
import { TDialogWrapperComponent } from 'components/dialog/index.types';
import DialogForm from '../../dialog/dialog-form';
import { Body1 } from 'components/typography';
import { RejectDialogWrapper, FormField, ErrorText } from '../index.styles';
import Input from '../../form/formik/input';
import { EButtonType } from 'components/control/button/button.types';

type TFormValues = {
  name_error: boolean;
  date_of_birth_error: boolean;
  place_of_birth_error: boolean;
  phone_number_error: boolean;
  NIK_mathes_existing_customer: boolean;
  employment_information_error: boolean;
  nationality_error: boolean;
  family_card_error: boolean;
  ID_address_mismatch: boolean;
  other_reason: string;
};

const initValues: TFormValues = {
  name_error: false,
  date_of_birth_error: false,
  place_of_birth_error: false,
  phone_number_error: false,
  NIK_mathes_existing_customer: false,
  employment_information_error: false,
  nationality_error: false,
  family_card_error: false,
  ID_address_mismatch: false,
  other_reason: '',
};

const DialogReject: React.FC<
  TDialogWrapperComponent & {
  onSubmit: ({ id, reason }: { id: string; reason: string }) => void;
  userId: string;
}
> = ({ setIsDialogOpen, isDialogOpen, onSubmit, userId }) => {
  const [error, setError] = useState('');

  return (
    <DialogForm
      isDialogOpen={isDialogOpen}
      setIsDialogOpen={setIsDialogOpen}
      title={'Reject KYC Submission'}
      initValues={initValues}
      labels={{ submit: 'Reject' }}
      submitButtonType={EButtonType.Danger}
      dontCloseAfterSubmit
      validate={(values) => {
        let errors: Partial<TFormValues> = {};

        if (values.other_reason.length < 6) {
          errors.other_reason = 'Min. 6 characters';
        }
        if (values.other_reason.length > 255) {
          errors.other_reason = 'Max. 255 characters';
        }
        return errors;
      }}
      onSubmit={(values) => {
        if (!error) {
          let filteredValues = [];
          for (const [key, value] of Object.entries(values)) {
            if (value && typeof value === 'string') {
              filteredValues.push(value);
            }
          }

          const stringifiedValues = filteredValues
            .map((value: string) => {
              return value.split('_').join(' ');
            })
            .join(', ');

          onSubmit({ id: userId, reason: stringifiedValues });
          setIsDialogOpen(false);
        }
      }}
    >
      <RejectDialogWrapper error={!!error}>
        <Body1>{'Please enter the reason of rejection (max 255 characters)'}</Body1>
        <Input
          name="other_reason"
          placeholder={'Reject reason'}
          multiline
          rows={4}
        />
      </RejectDialogWrapper>
      {error && <ErrorText>{error}</ErrorText>}
    </DialogForm>
  );
};

export default DialogReject;
